import { useCallback } from "react";
import { useLocation } from "react-router-dom";
import { useStableNavigate } from "../Components/StableNavigateContext";

const useNavigateToRoute = () => {
  const navigate = useStableNavigate();
  const { search } = useLocation();
  return useCallback(
    (routeId: string | null) => {
      const pathname = routeId
        ? `/dispatching/routes/${routeId}`
        : "/dispatching";
      navigate({ pathname, search });
    },
    [navigate, search]
  );
};

export default useNavigateToRoute;
